<template>
  <div :class="$style.agentPage">
    <app-loader :show-loader="loading" />
    <app-breadcrumbs :items="breadcrumbs" />
    <h4 v-if="agent">{{ getAgentsFullName }}</h4>
    <app-info-table v-if="agent"
                    title="Agent Information">
      <div :class="$style.agentInfo">
        <div :class="$style.agentInfoItem">
          <h6>First Name</h6>
          <p>{{ agent.firstName }}</p>
        </div>
        <div :class="$style.agentInfoItem">
          <h6>Number of Clients</h6>
          <p>{{ agent.numberOfClients }}</p>
        </div>
        <div :class="$style.agentInfoItem">
          <h6>Email</h6>
          <p>{{ agent.email }}</p>
        </div>
        <div :class="$style.agentInfoItem">
          <h6>Status</h6>
          <v-switch v-model="agent.isActive"
                    :label="getStatusLabel"
                    @change="updateAgentStatus($event)" />
        </div>
        <div :class="$style.agentInfoItem">
          <h6>Last Name</h6>
          <p>{{ agent.lastName }}</p>
        </div>
        <div :class="$style.agentInfoItem">
          <h6>Activated On</h6>
          <p>{{ agent.activatedOn }}</p>
        </div>
        <div :class="$style.agentInfoItem">
          <h6>Phone</h6>
          <p>{{ agent.phoneNumber }}</p>
        </div>
      </div>
    </app-info-table>
    <p v-if="error" :class="$forms.errorMessage">{{ error }}</p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatDate, formatPhone } from '@/utils';

export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Agents /',
          disabled: false,
          to: '/admin/agents',
        },
      ],
      agent: null,
      isActive: false,
      loading: false,
      error: null,
    };
  },
  methods: {
    ...mapActions([
      'fetchAgentDetails',
      'updateAgent',
    ]),
    updateAgentStatus(e) {
      const agentId = this.$route.params.id;
      const data = {
        agentId,
        updateData: { isActive: e },
      };
      this.loading = true;
      this.updateAgent(data)
        .catch((err) => {
          console.log(err);
          this.error = err.response.data.title;
          this.agent.isActive = !e;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      'getAgentDetails',
    ]),
    getStatusLabel() {
      return this.agent.isActive ? 'Active' : 'Inactive';
    },
    getAgentsFullName() {
      return `${this.agent.firstName} ${this.agent.lastName}`;
    },
  },
  created() {
    const agentId = this.$route.params.id;
    this.loading = true;
    this.fetchAgentDetails(agentId)
      .then(() => {
        this.agent = {
          ...this.getAgentDetails,
          phoneNumber: formatPhone(this.getAgentDetails.phoneNumber),
          activatedOn: formatDate(this.getAgentDetails.activatedOn),
        };
      })
      .catch((err) => {
        console.log(err);
        this.error = err;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style lang="scss" module>
@import "@/styles/variables.scss";

.agentPage {
  width: 100%;
  padding: 24px 50px;

  h4 {
    width: 100%;
    color: $adminPortalTitlesColor;
    font-size: 1.8rem;
    padding-bottom: 16px;
    border-bottom: 1px solid $adminTablesColor;
    margin-bottom: 20px;
  }
}

.agentInfo {
  display: flex;
  flex-wrap: wrap;

  .agentInfoItem {
    width: 25%;
  }
}
</style>
